module.exports = __webpack_public_path__ + "img/1-2.fab337fd.png";